<template lang="pug">
ul.nav
  li.p-3.has-sub
    b-input-group.searchbar
      input.form-control(type='text' v-model="search_id" :placeholder='$t("ui.search")' @keyup.enter.native="searchFrom")
      template(v-slot:append)
        b-button(variant="info" @click="searchFrom")
          i.fa.fa-search
//- ul.nav
//-   li.nav-profile
//-     a(href="#" @click="expand()")
//-       .cover.with-shadow
//-       .image.image-icon.bg-black.text-grey-darker
//-         v-gravatar(:email="$store.getters.loginID")
//-       .info
//-         //- b.caret.pull-right
//-         span {{ username }}
//-         small {{ $helpers.getUplineName($store.getters.accountType) }}
  //- li
  //-   ul.nav.nav-profile(:class="{ 'd-block': this.stat == 'expand' && !this.pageOptions.pageSidebarMinified, 'd-none': this.stat == 'collapse' }")
  //-     li
  //-       a(href="/settings")
  //-         i.fas.fa-lg.fa-fw.fa-cogs
  //-         span {{ $t("ui.settings") }}
  //-     li
  //-       a(href="/subAccount")
  //-         i.fas.fa-lg.fa-fw.fa-user-plus
  //-         span {{ $t("ui.sub_account") }}
</template>

<script>
import PageOptions from '../../config/PageOptions.vue'

export default {
	name: 'SidebarNavProfile',
	data() {
		return {
			stat: '',
      pageOptions: PageOptions,
      currentTime: null,
      search_id: ""
		}
  },
  computed: {
		username() {
      return this.$store.getters.displayName || this.$store.getters.loginID
    },
    loginID() {
      return this.$store.getters.accountID
    }
  },
	methods: {
    searchFrom: function() {
      if(this.search_id) {
        if(this.search_id.toLowerCase() != this.loginID) {
          this.$store.dispatch("user/setSelectedID", this.search_id)
          this.$router.push("/search").catch(err=>{})
        }
      }
    },
		expand: function() {
			this.stat = (this.stat == 'expand') ? 'collapse' : 'expand'
    },
    updateCurrentTime: function() {
      this.currentTime = this.$moment().format('MMMM Do YYYY, h:mm:ss A')
    }
  }
}
</script>
